import Vue from 'vue'
import token from '@/services/token'
import { Subject } from 'rxjs'
import { catchError } from 'rxjs/operators'

// 各コンポーネントからアクセスするときの名前登録（テンプレ）
Vue.mixin({
  beforeCreate() {
    const options = this.$options
    if (options.queryNotification)
      this.$queryNotification = options.queryNotification
    else if (options.parent && options.parent.$queryNotification)
      this.$queryNotification = options.parent.$queryNotification
  },
})

let subject = new Subject()
let eventSource

export default {
  connect() {
    return token.retrieveToken().then(t => {
      if (eventSource) {
        return
      }

      eventSource = new EventSource(
        `${process.env.VUE_APP_QUERY_API_URL_BASE}/api/query/progress?token=${
          t.accessToken
        }`,
      )

      eventSource.addEventListener('message', e => {
        let data
        try {
          data = JSON.parse(e.data)
          subject.next(data)
        } catch (error) {
          subject.error({
            message: 'サーバーとの接続が切断されました。',
            error,
          })
        }
      })

      eventSource.addEventListener('error', e => {
        if (eventSource) {
          eventSource.close()
        }
        subject.error({
          message: 'サーバーとの接続が切断されました。',
          error: e,
        })
      })
    })
  },
  observable: subject.asObservable().pipe(
    catchError(error => {
      // eslint-disable-next-line no-console
      console.warn(error)
      throw error
    }),
  ),
}
